export enum PfrRecurringType {
    "monthly" = "M",
    "weekly" = "W"
}